import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { IconContext } from "@phosphor-icons/react";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/jetbrains-mono/400.css";
import App from "./App";
import { theme } from "./theme";
import Landing from "./landing/Landing";
import Join from "./pages/Join";
import { Route, Routes } from "react-router-dom";
import { env, tenantFromHost } from "./env";

// One icon voice across the app: Phosphor, light weight.
const icons = { weight: "light" as const, size: 18, mirrored: false, color: "currentColor" };

const root = ReactDOM.createRoot(document.getElementById("root")!);

// The bare domain is the landing page only: no sign-in is offered there. /landing previews it on any host.
// A QR join link (/j/<pass>) identifies its session by the pass alone, so it renders on any host: a practice address
// on dev and prod, or the laptop's LAN name in the local loop (a phone cannot resolve *.localhost).
const joinLink = window.location.pathname.startsWith("/j/");
if (joinLink) {
  // no sign-in on the join page: the pass is the credential
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <IconContext.Provider value={icons}>
          <BrowserRouter>
            <Routes>
              <Route path="/j/:pass" element={<Join />} />
            </Routes>
          </BrowserRouter>
        </IconContext.Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (tenantFromHost() === "" || window.location.pathname === "/landing") {
  root.render(
    <React.StrictMode>
      <Landing />
    </React.StrictMode>
  );
} else {
  renderApp();
}

function renderApp() {
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={env.auth0Domain}
        clientId={env.auth0ClientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: env.auth0Audience,
          scope: "openid profile email offline_access",
        }}
        useRefreshTokens
        cacheLocation="localstorage"
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <IconContext.Provider value={icons}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </IconContext.Provider>
        </ThemeProvider>
      </Auth0Provider>
    </React.StrictMode>
  );
}
